/**
 * Environment detection utilities for MyVW Feature App
 */

/**
 * Check if the application is running in local development environment
 * @returns {boolean} True if running locally, false otherwise
 */
export const isLocalDevelopment = (): boolean => {
  if (typeof window === 'undefined') {
    // Server-side rendering or Node.js environment
    return false;
  }

  const hostname = window.location.hostname;
  
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === 'local.vwmyvwui.vw.com' ||
    hostname.includes('local') ||
    // Also check for common development ports
    (hostname === '0.0.0.0' && window.location.port !== '') ||
    // Check if running on Vite dev server default port
    window.location.port === '3000'
  );
};

/**
 * Check if the application is running in production environment
 * @returns {boolean} True if running in production, false otherwise
 */
export const isProduction = (): boolean => {
  return !isLocalDevelopment();
};

/**
 * Get the appropriate base URL for image processing based on environment
 * @returns {string} Base URL for image processing
 */
export const getImageProcessingBaseUrl = (): string => {
  if (isLocalDevelopment()) {
    return 'https://cs-int-vw-us.lighthouselabs.eu';
  }
  
  // In production, the CMS handles the proper URLs
  return '';
};

/**
 * Check if image processing should be enabled
 * @returns {boolean} True if image processing should be enabled
 */
export const shouldProcessImages = (): boolean => {
  return isLocalDevelopment();
};

/**
 * Get the appropriate auth base URL based on environment
 * @returns {string} Base URL for authentication
 */
export const getAuthBaseUrl = (): string => {
  if (isLocalDevelopment()) {
    return 'https://cs-int-vw-us.lighthouselabs.eu';
  }
  
  // For production/QA, use the current hostname
  if (typeof window !== 'undefined') {
    return `https://${window.location.hostname}`;
  }
  
  return 'https://vw.com';
};

/**
 * Get the complete signup URL based on environment
 * @returns {string} Complete signup URL
 */
export const getSignupUrl = (): string => {
  const baseUrl = getAuthBaseUrl();
  const authPath = '/app/authproxy/login/vw-en-myvw?scope=openid&prompt=login';
  
  return `${baseUrl}${authPath}`;
};